import { render, staticRenderFns } from "./FieldsAndPaths.vue?vue&type=template&id=587517ea&scoped=true"
import script from "./FieldsAndPaths.vue?vue&type=script&lang=ts"
export * from "./FieldsAndPaths.vue?vue&type=script&lang=ts"
import style0 from "./FieldsAndPaths.vue?vue&type=style&index=0&id=587517ea&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587517ea",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VIcon,VList,VListGroup,VListItem,VListItemContent,VListItemIcon,VListItemTitle,VProgressLinear,VRow,VSnackbar})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/apps/front/flightpath-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('587517ea')) {
      api.createRecord('587517ea', component.options)
    } else {
      api.reload('587517ea', component.options)
    }
    module.hot.accept("./FieldsAndPaths.vue?vue&type=template&id=587517ea&scoped=true", function () {
      api.rerender('587517ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FieldsAndPaths.vue"
export default component.exports